<template>
<div>
    <v-card dark class="pa-4 grey darken-3 ma-4">
        <v-toolbar dark flat dense class="grey darken-3">
            <v-toolbar-title>Картка адміністратора</v-toolbar-title>
            <v-btn icon @click="getDataFromApi()" title="Оновити">
                <v-icon color="grey">mdi-cached</v-icon>
            </v-btn>
        </v-toolbar>
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
            <v-card-text>
                <v-flex xs4 lg1>
                    <v-text-field v-model="f.id" label="ID" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required|tel">
                        <v-text-field @keyup="_checkPhone()" prepend-icon="mdi-phone" :loading="checkLoading" v-model="f.phone" label="Телефон" :error-messages="errors" placeholder="+38(000) 000 - 0000" v-mask="maskTel"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required">
                        <v-text-field v-model="f.surname" :error-messages="errors" label="Прізвище"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required">
                        <v-text-field v-model="f.firstname" :error-messages="errors" label="Ім’я"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required">
                        <v-text-field v-model="f.lastname" :error-messages="errors" label="Отчество"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required|email">
                        <v-text-field v-model="f.email" prepend-icon="mdi-email" :error-messages="errors" label="Email"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-select v-model="f.permissions" label="Групи доступу" chips multiple persistent-hint cache-items :items="itemsGroups" prepend-icon="mdi-format-list-bulleted-type"></v-select>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-select v-model="f.references" chips multiple persistent-hint cache-items :items="itemsReferences" label="Доступи до Довідників"></v-select>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="grey" @click="goBack()">
                    <v-icon color="grey">mdi-keyboard-return</v-icon> Повернутись
                </v-btn>
                <v-btn color="cardheader" text @click="submitForm()">Зберегти</v-btn>
            </v-card-actions>
        </ValidationObserver>
    </v-card>
</div>
</template>

<script>
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

import {
    mapActions
} from 'vuex'

import {
    mask
} from 'vue-the-mask'

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    directives: {
        mask
    },
    data() {
        return {
            f: {},
            maskTel: '+38(###) ###-####',
            checkLoading: false
        }
    },
    methods: {
        ...mapActions(['editAdmin', 'setSnackbar', 'getAccessGroups', 'getUserAccessGroups', 'getReferences', 'updateAdmin', 'touch', 'checkPhone']),
        getDataFromApi() {
            this.touch()
                .then(() => {
                    this.editAdmin(this.$route.params.id)
                    .then(data => this.f = data || {})
                    this.getAccessGroups()
                    this.getUserAccessGroups(this.$route.params.id)
                        .then(data => {
                            this.f.permissions = data || {}
                        })
                    this.getReferences(this.$route.params.id)
                        .then(data => {
                            this.f.references = data.userReference
                        })
                })

        },
        goBack() {
            window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel/admins')
        },
        async submitForm() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) {
                this.setSnackbar(['error', 'Заповнiть усi необхiднi поля'])
            } else {
                // transform select Obj to Array
                this.f.permissions = this.f.permissions.map(e => e.value ? e.value : e)
                this.f.references = this.f.references.map(e => e.value ? e.value : e)

                this.updateAdmin(this.f)
                    .then(() => {
                        this.setSnackbar(['info', 'Успiшно збережено'])
                        this.goBack()
                    })
                    .catch(error => {
                        this.setSnackbar(['error', error])
                    })
            }
        },
        _checkPhone() {
            if (this.f.phone.length === 17) {
                this.checkLoading = true

                this.checkPhone({phone: this.f.phone, id: this.f.id})
                .then(data => {
                    this.checkLoading = false
                    if (data.success) {
                        this.setSnackbar(['error', "Цей номер вже існує"])
                    } 
                })
                .catch(error => {
                    this.setSnackbar(['error', error])
                })
            } else {
                this.checkLoading = false
            }
        }
    },
    created() {
        this.getDataFromApi()
    },
    computed: {
        adminCard() {
            return this.$store.state.adminpanel.adminCard
        },
        itemsGroups() {
            return this.$store.state.adminpanel.accessGroups
        },
        userAccessGroups() {
            return this.$store.state.adminpanel.userAccessGroups
        },
        itemsReferences() {
            return this.$store.state.adminpanel.references
        },
        userReferences() {
            return this.$store.state.adminpanel.userReferences
        },
    }
}
</script>

<style>
</style>
